import {Pipe, PipeTransform} from '@angular/core';
import {Centre} from "../models/centre";

@Pipe({
  name: 'centrePipe'
})
export class CentrePipe implements PipeTransform {
  transform(centre: Centre): string {
    return centre.name + " <br/><small>" + centre.code + "</small>" ;
  }
}
